// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';


export class RotateEntityAction implements flatbuffers.IUnpackableObject<RotateEntityActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):RotateEntityAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsRotateEntityAction(bb:flatbuffers.ByteBuffer, obj?:RotateEntityAction):RotateEntityAction {
  return (obj || new RotateEntityAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsRotateEntityAction(bb:flatbuffers.ByteBuffer, obj?:RotateEntityAction):RotateEntityAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new RotateEntityAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.MapRotateEntity;
}

entityId():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
}

heading():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

static startRotateEntityAction(builder:flatbuffers.Builder) {
  builder.startObject(3);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.MapRotateEntity);
}

static addEntityId(builder:flatbuffers.Builder, entityId:number) {
  builder.addFieldInt32(1, entityId, 0);
}

static addHeading(builder:flatbuffers.Builder, heading:number) {
  builder.addFieldInt32(2, heading, 0);
}

static endRotateEntityAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createRotateEntityAction(builder:flatbuffers.Builder, type:ActionType, entityId:number, heading:number):flatbuffers.Offset {
  RotateEntityAction.startRotateEntityAction(builder);
  RotateEntityAction.addType(builder, type);
  RotateEntityAction.addEntityId(builder, entityId);
  RotateEntityAction.addHeading(builder, heading);
  return RotateEntityAction.endRotateEntityAction(builder);
}

unpack(): RotateEntityActionT {
  return new RotateEntityActionT(
    this.type(),
    this.entityId(),
    this.heading()
  );
}


unpackTo(_o: RotateEntityActionT): void {
  _o.type = this.type();
  _o.entityId = this.entityId();
  _o.heading = this.heading();
}
}

export class RotateEntityActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.MapRotateEntity,
  public entityId: number = 0,
  public heading: number = 0
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return RotateEntityAction.createRotateEntityAction(builder,
    this.type,
    this.entityId,
    this.heading
  );
}
}
